import { APP_INITIALIZER, NgModule, provideZoneChangeDetection } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './core/interceptor/auth.interceptor';
import { MatToolbar } from '@angular/material/toolbar';
import { NgxSpinnerModule } from 'ngx-spinner';
import { httpRespInterceptor } from './core/interceptor/http-resp.interceptor';
import { BrowserModule } from '@angular/platform-browser';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { DatePipe } from '@angular/common';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { IpHeaderInterceptor } from './core/interceptor/ipAddress.interceptor';
import { IpService } from './core/services/ipAddress.service';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { SharedModule } from './shared/shared/shared.module';
import { providePrimeNG } from 'primeng/config';
import Lara from '@primeng/themes/lara';
import { definePreset } from '@primeng/themes';

// PrimeNG 17 shipped the 'lara-light-blue' CSS theme. PrimeNG 21 replaced CSS
// themes with presets: Lara is the same design lineage but defaults to an
// emerald primary, so the palette is overridden back to blue here.
const LaraLightBlue = definePreset(Lara, {
  semantic: {
    primary: {
      50: '{blue.50}', 100: '{blue.100}', 200: '{blue.200}', 300: '{blue.300}',
      400: '{blue.400}', 500: '{blue.500}', 600: '{blue.600}', 700: '{blue.700}',
      800: '{blue.800}', 900: '{blue.900}', 950: '{blue.950}'
    }
  }
});

export function initApp(ipService: IpService): () => Promise<void> {
  return () => ipService.fetchPublicIp();
}

@NgModule({
  declarations: [
    AppComponent,
    

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MatToolbar,
    NgxSpinnerModule.forRoot(),
    ToastrModule.forRoot({
      timeOut: 3000, 
      positionClass: 'toast-top-right', 
      preventDuplicates: true, 
    }),  
    BrowserAnimationsModule,
    SharedModule,
  ],
  providers: [
    // Angular 21 defaults new apps to zoneless change detection. This app has 363
    // components on default change detection and no signals, so zone-based change
    // detection is stated explicitly rather than left to the framework default.
    provideZoneChangeDetection(),
    IpService,
    {
      provide: APP_INITIALIZER,
      useFactory: initApp,
      deps: [IpService],
      multi: true
    },
    DatePipe,
    providePrimeNG({ theme: { preset: LaraLightBlue, options: { darkModeSelector: false } } }),
    provideHttpClient(withInterceptors([IpHeaderInterceptor])),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideHttpClient(withInterceptors([httpRespInterceptor])),
    provideCharts(withDefaultRegisterables()),
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    {provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: {hasBackdrop: false}}

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
